<template>
    <div :class="horizontal ? 'd-flex flex-row' : ''">
        <div v-if="!noLabel" class="d-flex align-items-center" :class="labelClass" :style="labelStyle">
            <label class="w-100 text-nowrap">
                {{ label ? label : config.label }}
                :
            </label>
        </div>
        <div class="d-flex flex-row position-relative" :class="formClass" :style="formStyle">
            <b-form-input v-if="isType(TYPES.STRING)"
                          v-model="tempValue"
                          type="text"
                          debounce="300">
            </b-form-input>
            <b-form-input v-if="isType(TYPES.NUMBER)"
                          v-model="tempValue"
                          type="number"
                          :min="config.min"
                          :max="config.max"
                          debounce="300">
            </b-form-input>
            <b-form-input v-if="isType(TYPES.COLOR)"
                          v-model="tempValue"
                          type="color"
                          debounce="300">
            </b-form-input>
            <b-form-select v-else-if="isType(TYPES.SELECT)"
                           v-model="tempValue"
                           :options="config.options">
            </b-form-select>
            <b-form-textarea v-else-if="isType(TYPES.TEXTAREA)"
                             v-model="tempValue"
                             debounce="500"
                             rows="3">
            </b-form-textarea>
            <b-form-checkbox v-else-if="isType(TYPES.BOOLEAN)"
                             v-model="tempValue"
                             switch>
            </b-form-checkbox>
            <b-avatar size="12" variant="danger" icon="x-lg" button class="avatar-cover"
                      @click="$emit('delete')"></b-avatar>
        </div>
    </div>
</template>

<script>
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    name: "MiniFormInput",
    model: {
        prop: 'value',
        event: 'update'
    },
    mixins: [emCommonUtilMixin],
    props: {
        label: {
            type: String,
            default: '',
        },
        value: {
            required: true
        },
        type: {
            type: String
        },
        config: {
            type: Object,
            default: () => {
            },
        },
        horizontal: {
            type: Boolean,
            default: false
        },
        labelWidthRate: {
            type: [Number, String],
            default: 3
        },
        noLabel: {
            type: Boolean,
            default: false
        },
        widthPx: {
            type: Array
        }
    },
    data() {
        return {
            TYPES: {
                STRING: 'string',
                NUMBER: 'number',
                COLOR: 'color',
                SELECT: 'select',
                BOOLEAN: 'boolean',
                TEXTAREA: 'textarea'
            },
            tempValue: null,
            changed: false,
        }
    },
    computed: {
        labelClass() {
            let temp = [];
            if (!this.widthPx) {
                temp.push('w-100');
                if (this.horizontal) {
                    temp.push('col-' + this.labelWidthRate);
                }
            }
            return temp.join(" ");
        },
        formClass() {
            let temp = [];
            if (!this.widthPx && this.horizontal) {
                temp.push('col-' + (this.noLabel ? 12 : (12 - this.labelWidthRate)));
            }
            return temp.join(" ");
        },
        labelStyle() {
            if (this.widthPx && this.widthPx.length === 2) {
                return `width: ${this.widthPx[0]}px;`;
            } else {
                return '';
            }
        },
        formStyle() {
            if (this.widthPx && this.widthPx.length === 2) {
                return `width: ${this.widthPx[1]}px;`;
            } else {
                return '';
            }
        },
    },
    watch: {
        tempValue() {
            this.whenTempValueChange();
        },
        value: {
            handler() {
                if (this.isType(this.TYPES.COLOR)) {
                    this.tempValue = this.hasCode(this.value) ? this.value : '#ffffff';
                } else {
                    this.tempValue = this.value;
                }
            },
            immediate: true
        }
    },
    methods: {
        whenTempValueChange() {
            let temp = this.tempValue;
            this.$emit('update:value', temp);
        },
        isType(...types) {
            let temp = this.type ? this.type : this.config.type;
            for (let t of types) {
                if (t === temp) {
                    return true;
                }
            }
            return false;
        },
    }
}
</script>

<style scoped>
label {
    height: max-content;
}

.position-relative:hover .avatar-cover {
    opacity: 1;
}

.avatar-cover {
    position: absolute;
    top: 0;
    right: 0;
    opacity: 0;
    z-index: 99;
    transition: opacity ease-out .3s;
}

.avatar-cover:hover {
    opacity: 1;
}
</style>